// Texto único de Habeas Data, compartido entre el formulario público de
// autoregistro y el registro completo interno (admin/operador) para que
// ambos muestren siempre la misma declaración.
export const HABEAS_DATA_TEXTO = '¿Autoriza el registro y uso de sus datos conforme a la siguiente declaración? '
  + 'Toda la información suministrada está protegida por la ley de protección de datos personales '
  + '(Ley 1581 de 2012 y Decreto 1377 de 2013). En ningún caso se utilizará la información con otros '
  + 'fines distintos de los acá expuestos. Autorizo al Departamento Administrativo de Competitividad a '
  + 'contactarme telefónicamente y ser caracterizado en su base de datos, invitarme a conocer la oferta '
  + 'institucional, compartir sus datos con entidades aliadas con el propósito de que tenga la oportunidad '
  + 'de acceder a programas que beneficien mi emprendimiento en pro del mejoramiento de mi calidad de vida, '
  + 'e invitarme a eventos, capacitaciones y otras actividades para fortalecer la relación entre la Entidad '
  + 'y los actores afines.';
